import Vue from "vue"
import App from "./App"
import router from "./router"

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: "../static/images/error.jpg",
	loading: "../static/images/loading.gif",
	attempt: 1,
	listenEvents: ["scroll", "wheel", "mousewheel", "resize", "animationend", "transitionend"]
})

Vue.config.productionTip = false;
/* eslint-disable no-new */
import VueRunSfc from "vue-run-sfc";
Vue.use(VueRunSfc);
new Vue({
	el: "#app",
	router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js